import React from 'react';
import { Link } from 'react-router-dom';

/** Hero — source: mockup L209–287 (sessions phone mock L233–284). */
const Hero = (): React.JSX.Element => (
  <section className="oq-hero">
    <div className="oq-hero__glow oq-hero__glow--top" aria-hidden="true" />
    <div className="oq-hero__glow oq-hero__glow--bottom" aria-hidden="true" />
    <div className="oq-hero__inner">
      <div className="oq-hero__row">
        <div className="oq-hero__copy">
          <div className="oq-hero__badge">
            <span className="oq-hero__badge-dot" />
            <span className="oq-hero__badge-text oq-bebas">CLUB MANAGEMENT SOFTWARE</span>
          </div>
          <h1 className="oq-hero__title oq-bebas">
            The sports club app<br />
            your members<br />
            <span className="oq-hero__title-accent">actually love</span>
          </h1>
          <p className="oq-hero__subtitle">
            Session booking, membership management, club website and payments — in your club&apos;s
            app. Everything your committee runs on WhatsApp, spreadsheets and three separate tools,
            in one.
          </p>
          <div className="oq-hero__ctas">
            <Link to="/contact-us" className="oq-hero__cta-primary">Book a demo</Link>
            <Link to="/compare" className="oq-hero__cta-secondary">
              Compare vs Spond <i className="mdi mdi-arrow-right" aria-hidden="true" />
            </Link>
          </div>
          <div className="oq-hero__bullets">
            <div className="oq-hero__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" /> No fixed monthly fees
            </div>
            <div className="oq-hero__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" /> Payouts to your own Stripe
            </div>
            <div className="oq-hero__bullet">
              <i className="mdi mdi-check-circle" aria-hidden="true" /> Live in days, not months
            </div>
          </div>
        </div>

        <div className="oq-hero__phone" aria-hidden="true">
          {/* Real app screenshot, used exactly as supplied — it carries its own
              device frame on a transparent background, so no PhoneFrame here. */}
          <img
            src="/images/hero-sessions.png"
            alt=""
            className="oq-hero__shot"
            width="1080"
            height="1920"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
